<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="9" cols="12">
          <ModuleHeader>Bahias por actividad</ModuleHeader>
        </v-col>
        <v-col md="3" cols="12">
          <v-autocomplete
            label="Actividad"
            v-model="rvaDepto"
            @input="getBahias()"
            :items="actividades"
            item-text="nm"
            item-value="id"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-alert v-if="!rvaDepto" dense type="info">
        Selecciona una actividad para administrar sus bahias de salida
      </v-alert>
      <uv-data-table
        v-if="rvaDepto"
        :config="config"
        :data="bahias"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Bahia">
      <BahiasForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </BahiasForm>
    </modal>
  </div>
</template>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import ApiBioTime from "../../../clases/ApiBioTime.js";
import BahiasForm from "./BahiasForm.vue";
import axiosCore from "axios";
import { mapGetters } from "vuex";
export default {
  name: "BahiasCRUD",
  components: {
    uvDataTable,
    BahiasForm,
  },
  props: [],
  data() {
    return {
      actividades: [],
      bahias: [],
      rvaDepto: null,
      formIndex: 0,
      editMode: false,
      editData: {},
      showModal: false,
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Bahias de salida",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addBahia",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarBahia",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteBahia",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Orden",
            value: "od",
          },
        ],
      },
      idSelected: "",
    };
  },
  computed: {
    departamentos() {
      let deptos = [];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        if (dep.id != "Golf") {
          (dep.text = dep.Nombre), (dep.value = dep.id);
          deptos.push(dep);
        }
      });
      return deptos;
    },
  },
  methods: {
    async getActividades() {
      let actividades = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Actividades"
      );
      if (snapshot.val()) {
        let docs = Object.entries(snapshot.val());
        docs.forEach((element) => {
          actividades.push({ id: element[0], ...element[1] });
        });
        this.actividades = actividades;
      }else{
        this.actividades = []
      }
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createBahia(data);
      } else {
        this.updateBahia(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addBahia") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        //this.$refs.modalForm.setTitle("Agregar MetodoPago");
        this.toggleModal(true);
      }
      if (buttonId == "editarBahia") {
        this.idSelected = idSelected[0];
        const mp = this.$pgsHelper.getById(this.bahias, "id", idSelected[0]);
        
        this.editMode = true;
        this.editData = mp;

        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia") {
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deleteBahia") {
        const mp = this.$pgsHelper.getById(this.bahias, "id", idSelected[0]);
        if (mp.Prtgdo) {
          this.$swal(
            "No se puede editar un metodo de pago protegido",
            "",
            "error"
          );
          return false;
        }
        this.deleteBahia(idSelected[0]);
      }
    },
    async getBahias() {
      let bahias = [];
      const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "ACT/Bahias"
      );
      if (snapshot.val()) {
      let docs = Object.entries(snapshot.val());
      docs.forEach((element) => {
        if(element[1].ia == this.rvaDepto){
          bahias.push({ id: element[0], ...element[1] });
        }
        
      });
      }
      this.bahias = bahias;
    },
    createBahia(data) {
      data.ia = this.rvaDepto
      data.od = Number(data.od)
      this.$swal({
        title: "¿Deseas guardar la bahia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Bahias-createBahia", data)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La bahia se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getBahias()
            });
          } else {
            this.$swal("Error saving bahia", result.value.data.error, "error");
          }
        }
      });
    },
    updateBahia(data) {
      data.ia = this.rvaDepto
      data.od = Number(data.od)
      this.$swal({
        title: "¿Deseas editar la bahia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Bahias-updateBahia", data)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La bahia se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getBahias()
            });
          } else {
            this.$swal("Error saving bahia", result.value.data.error, "error");
          }
        }
      });
    },
    deleteBahia(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar esta bahia?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ACT-Bahias-deleteBahia", datos)
            .then(function(result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("La bahia se elimino correctamente", "", "success");
            //this.getClientes();
            this.getBahias()
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function() {},
  mounted: async function() {
    this.getActividades();
  },
};
</script>
